import fetch from '@/utils/fetch'
import {
  shop_url
} from '@/global'

const MAIN_DATA = `${shop_url}/shop/mp/historyInfo`

/**
 * 获取首页数据
 */
const getMainData = () => {
  return fetch({
    url: MAIN_DATA,
    method: 'get'
  })
}

/**
 * 获取首页总资产
 */
const mainTop = (mchId) => {
  return fetch({
    url: `${shop_url}/shop/mp/index/${mchId}`,
    method: 'get'
  })
}

export {
  mainTop,
  getMainData
}



// WEBPACK FOOTER //
// ./src/api/main/index.js